import { render, staticRenderFns } from "./Modal-search.vue?vue&type=template&id=0b2786ee&scoped=true&lang=pug"
import script from "./Modal-search.vue?vue&type=script&lang=js"
export * from "./Modal-search.vue?vue&type=script&lang=js"
import style0 from "./Modal-search.vue?vue&type=style&index=0&id=0b2786ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2786ee",
  null
  
)

export default component.exports